/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

import store from "store/store";

/**
 * Formats a number as a price string with two decimal places
 * Uses the currency configured in general settings (USD or MXN)
 * @param value - The numeric value to format
 * @returns A formatted price string in the format "$ XX.XX CURRENCY"
 */
export const formatPrice = (value: number): string => {
  // Get currency from general settings in the store
  const state = store.getState();
  const currency = state.generalSettings?.currency || 'USD';

  const num = Number(value);
  if (isNaN(num)) return String(value);
  return "$ " + num.toFixed(2) + " " + currency;
};

export const formatPriceInTheOtherCurrency = (value: number): string => {
  // Get currency from general settings in the store
  const state = store.getState();
  const currency = state.generalSettings?.currency === 'USD' ? 'MXN' : 'USD';

  const num = Number(value);
  if (isNaN(num)) return String(value);
  return "$ " + num.toFixed(2) + " " + currency;
};
